import {actionCreators} from "../../state";
import {SettingsRepository} from "../../repository/api/settings/settings";
import {OperatorUpdateCalculationSettingsRequest} from "../../repository/api/generated/callApi";
import {OktellRepository} from "../../repository/api/occupancy_service/oktell/oktell";

export class SettingsCallApiUseCases {
    private api: SettingsRepository;
    private oktellApi: OktellRepository;
    private stateActions: typeof actionCreators;

    constructor(api: SettingsRepository, stateActions: typeof actionCreators) {
        this.api = api;
        this.stateActions = stateActions;
        this.oktellApi = new OktellRepository()
    }

    public ReadSettings = async (signal?: AbortSignal) => {
        this.stateActions.SendSettingsCallApiListRequest()
        let response = await this.api.ReadSettings(signal)
        if (response instanceof Error) {
            this.stateActions.SettingsCallApiListError(response.message)
            return
        } else {
            this.stateActions.SettingsCallApiSuccess(response)
        }
    }

    public UpdateSettings = async (arg: OperatorUpdateCalculationSettingsRequest, callback?: ()=>void) => {
        this.stateActions.SettingsCallApiUpdateRequest()
        let response = await this.api.UpdateSettings(arg)
        if (response instanceof Error) {
            this.stateActions.SettingsCallApiUpdateError(response.message)
            return
        } else {
            this.stateActions.SettingsCallApiUpdateSuccess(response)
            if (callback) {
                callback()
            }
        }
    }

    public GetStatuses = async () => {
        let response = await this.oktellApi.ReadStatuses()
        if (response instanceof Error) {
            return Promise.reject(response);
        } else {
            return response
        }
    }

}